<app-header (locale)="onLocaleChange($event)"></app-header>
<div class="app-body pt-0 mt-1">
  <main class="main d-flex align-items-center">
    <div class="container pt-0">
      <div class="d-flex flex-row">
        <div class="card mx-auto">
          <div
            class="card-body card_width px-4 px-md-5 py-3 py-md-5 shadow-no-mobile shadow mx-auto"
          >
            <div
              *ngIf="(state$ | async).status === 'FAILED'"
              role="alert"
              class="alert alert-danger"
            >
              <strong>Error!</strong> {{ (state$ | async).errorMessage }}
            </div>

            <form [formGroup]="passwordUpdateForm">
              <h1
                class="primary-brand-color"
                data-testid="update-password-heading"
              >
                {{ 'admin.updatePassword.header' | translate }}
              </h1>
              <p class="primary-brand-color mb-3">
                <b>{{ 'admin.updatePassword.subHeader' | translate }}</b>
              </p>
              <div class="row">
                <div class="col-12">
                  <div class="input-group mb-3">
                    <label class="d-flex w-100 primary-brand-color" for="email">
                      {{ 'admin.global.email' | translate }}
                    </label>
                    <app-input-text
                      [bare]="true"
                      [value]="(state$ | async).username"
                      [readonly]="true"
                      [isDisabled]="true"
                      inputId="update-password-email-field"
                      cssClass="form-control-lg"
                    ></app-input-text>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-group mb-3">
                    <label class="d-flex w-100 primary-brand-color" for="email">
                      {{ 'admin.global.password' | translate }}
                    </label>
                    <app-input-text
                      [bare]="true"
                      [control]="$any(password)"
                      inputType="password"
                      placeholder="Password"
                      inputId="update-password-field"
                      autocomplete="password"
                      [maxLength]="100"
                      cssClass="form-control-lg"
                    ></app-input-text>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row justify-content-center mt-4">
                <app-button
                  type="button"
                  id="update-password-submit-button"
                  variant="primary"
                  class="w-100"
                  classes="w-100 py-3 font-weight-bold"
                  (click)="update()"
                  [disabled]="passwordUpdateForm.invalid"
                >
                  {{ 'admin.global.update' | translate }}
                </app-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
